/*
 * Jira Ticket:
 * Created Date: Wed, 8th Apr 2020, 11:42:05 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import moment from 'moment';

export const getListTowerQuery = gql`
  query allTowers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: TowerFilter
  ) {
    items: allTowers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      site {
        id
        name
        project {
          id
          name
          organisation {
            id
            name
          }
        }
      }
      createdAt
    }
    total: _allTowersMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export default ({ client, params }) => {
  try {
    delete params.target;
    delete params.id;
    if (params.filter.createdBefore)
      params.filter.createdBefore = moment(params.filter.createdBefore).endOf(
        'day'
      );
    if (params.filter.createdAfter)
      params.filter.createdAfter = moment(params.filter.createdAfter).startOf(
        'day'
      );
    return client.query({
      query: getListTowerQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort.field,
        sortOrder: params.sort.order,
        page: !params.pagination.page ? 0 : params.pagination.page - 1,
        perPage: params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
